import Styles from './EmptyPrompt.module.scss'
import { isMacintosh } from 'utils'

interface Props {
  inlineCompletion: boolean
  isEmptyDoc: boolean
  aiPromptEnabled: boolean
}

const EmptyPromptContent = ({ inlineCompletion = false, isEmptyDoc = false, aiPromptEnabled }: Props) => {
  if (isEmptyDoc && aiPromptEnabled) {
    return <BlankDocEmptyPromptContent />
  }
  return inlineCompletion ? (
    <InlineCompletionEmptyPromptContent aiPromptEnabled={aiPromptEnabled} />
  ) : (
    <DefaultEmptyPromptContent />
  )
}

const DefaultEmptyPromptContent = () => (
  <div className={Styles.contentContainer}>
    Type{' '}
    <span className={Styles.slashContainer} id="empty-prompt">
      /
    </span>{' '}
    to browse elements
  </div>
)

const InlineCompletionEmptyPromptContent = ({ aiPromptEnabled }: { aiPromptEnabled: boolean }) => {
  if (aiPromptEnabled) {
    return (
      <div className={Styles.contentContainer}>
        Press <kbd>{isMacintosh() ? '⌘' : 'ctrl+'}↵</kbd> to write more, or <kbd>space</kbd> to tell Blaze what to write
      </div>
    )
  }
  return (
    <div className={Styles.contentContainer}>
      Press <kbd>{isMacintosh() ? '⌘' : 'ctrl+'}↵</kbd> to write more, type{' '}
      <span className={Styles.slashContainer} id="empty-prompt">
        /
      </span>{' '}
      to insert elements
    </div>
  )
}
const BlankDocEmptyPromptContent = () => (
  <div className={Styles.contentContainer}>
    Press <kbd>space</kbd> to tell Blaze what to write
  </div>
)

export default EmptyPromptContent
